import axios from 'axios';
import { createAxiosClient } from './axios-client';

export class AxiosHttpClient {
  axiosClient: any;
  constructor(instance) {
    this.axiosClient = createAxiosClient(instance);
  }

  get(url, opts) {
    return this.axiosClient.get(url, opts).then((_) => _.data);
  }

  post(url, body) {
    return this.axiosClient.post(url, body).then((_) => _.data);
  }

  get CancelToken() {
    return axios.CancelToken;
  }

  isCancel(err) {
    return axios.isCancel(err);
  }
}
